import api from '../../utils/services/api';

import {
  listUsersActionError,
  listUsersActionLoading,
  listUsersActionSuccess,
  listNewUsersActionError,
  listNewUsersActionLoading,
  listNewUsersActionSuccess,
} from '../ducks/listUsers';

export const listUsersFetchAction = (filtro = { limit: 10, page: 1 }) => {
  return async (dispatch) => {
    dispatch(listUsersActionLoading());
    try {
      const response = await api.post('usuario/listar/todos', filtro);
      dispatch(listUsersActionSuccess(response.data));
    } catch (error) {
      dispatch(listUsersActionError(error?.response?.data));
    }
  };
};

export const listNewUsersFetchAction = () => {
  return async (dispatch) => {
    dispatch(listNewUsersActionLoading());
    try {
      const response = await api.get('usuario/buscar/entrada-usuarios');
      dispatch(listNewUsersActionSuccess(response.data));
    } catch (error) {
      dispatch(listNewUsersActionError(error?.response?.data));
    }
  };
};
